var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "story-header-component" }, [
    _vm.sticker
      ? _c("div", { staticClass: "story-header-component__sticker" }, [
          _c(
            "div",
            { staticClass: "story-header-component__sticker-container" },
            [
              _vm.editMode
                ? _c(
                    "div",
                    {
                      staticClass:
                        "story-header-component__remove-sticker-button",
                      attrs: {
                        tabindex: "0",
                        role: "button",
                        "aria-label": "Remove Sticker",
                      },
                      on: {
                        click: _vm.removeSticker,
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.removeSticker.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-times",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("render-sticker", { attrs: { sticker: _vm.sticker } }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.editMode && !_vm.sticker
      ? _c(
          "div",
          { staticClass: "story-header-component__sticker-placeholder" },
          [
            _c(
              "div",
              {
                staticClass:
                  "story-header-component__attach_button story-header-component__attach_button_blue",
                attrs: {
                  role: "button",
                  "aria-label": "Add Sticker",
                  tabindex: "0",
                },
                on: {
                  click: _vm.addSticker,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.addSticker.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "far fa-thumbs-up",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "far fa-heart",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.text && !_vm.isHeader
      ? _c("div", { staticClass: "story-header-component__text-container" }, [
          _c("span", { domProps: { innerHTML: _vm._s(_vm.textToDisplay) } }),
          _vm._v(" "),
          _vm.editMode
            ? _c(
                "span",
                {
                  staticClass: "story-header-component__round-edit-button",
                  attrs: {
                    tabindex: "0",
                    role: "button",
                    "aria-label": "Edit Description",
                  },
                  on: {
                    click: _vm.editDescription,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.editDescription.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-pencil",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              )
            : _vm._e(),
        ])
      : _vm.text && _vm.isHeader
      ? _c(
          "div",
          {
            staticClass:
              "story-header-component__text-container story-header-component__text-container_header",
          },
          [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.textToDisplay) } }),
            _vm._v(" "),
            _vm.editMode
              ? _c(
                  "span",
                  {
                    staticClass: "story-header-component__round-edit-button",
                    attrs: {
                      tabindex: "0",
                      role: "button",
                      "aria-label": "Edit Description",
                    },
                    on: {
                      click: _vm.editDescription,
                      keydown: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.editDescription.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-pencil",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm.editMode
      ? _c(
          "div",
          {
            staticClass:
              "story-header-component__text-container story-header-component__text-container_add-holder",
          },
          [
            _c(
              "div",
              {
                staticClass: "story-header-component__add-description-label",
                attrs: {
                  tabindex: "0",
                  role: "button",
                  "aria-label": "Add Description",
                },
                on: {
                  click: _vm.editDescription,
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.editDescription.apply(null, arguments)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" Add description\n        "),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "story-header-component__attach_button-label",
        attrs: { "aria-hidden": "true" },
      },
      [
        _vm._v("\n                        + "),
        _c("span", [_vm._v("Add")]),
        _vm._v(" Sticker\n                    "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }